import React from "react";
import styled from "styled-components";
import ChapterIcon from "../../../../../components/Images/ChapterIcon";
import Headphone from "../../../../../components/Images/Headphone";

const ChapterSeriesTabHolder = styled.div`
    display: flex;
    position: relative;
    box-shadow: 0 0 1px 0 rgba(#185ee0, 0.15), 0 6px 12px 0 rgba(#185ee0, 0.15);
    border-radius: 20px;
    background-color: var(--Dove);
    padding: 8px 16px;
    height:100%;
    justify-content: space-between;
    cursor: pointer;
	transition: color 0.15s ease-in;
    * {
        z-index: 2;
    }
    @media(max-width: 600px){
        width: unset;
        border-radius: 99px;
    }
`

const Glider = styled.span`
    position: absolute;
    display: flex;
    height: 40px;
    width: ${({ width }) => width || 100}px;
    background-color: rgba(	6, 138, 226, 0.08);
    z-index: 1;
    border-radius: 16px;
    transition: 0.40s ease-out;
    @media(max-width:600px){
        border-radius: 20px;
    }
`


const TabLabel = styled.label`
    font-size: 14px;
    font-weight: bold;
    line-height: 20px;
    color: rgba(13, 21, 54, 0.65);
    text-align: center;
    padding: 8px;
    display: flex;
    justify-content: center;
    @media(max-width: 600px){
        font-size: 14px;
    }
`

const StyledRadioInput = styled.input.attrs({ type: 'radio' })`
    display: none;  
    &:checked {
        & + ${TabLabel} {
            color: #068AE2;
        }
    }
`


const Radio1Input = styled(StyledRadioInput).attrs({ id: 'radio-1'})`
    &:checked {
        & ~ ${Glider}  {
            transform: translateX(0);
        }
    }
`

const Radio2Input = styled(StyledRadioInput).attrs({ id: 'radio-2'})`
    &:checked {
        & ~ ${Glider}  {
            transform: translateX(40px);
        }
    }
`



const payoutTabsObject = [
    {name: 'chapters', label: 'Chapters',RadioComp: Radio1Input, ImgComp: ChapterIcon },
    {name: 'audioseries', label: 'AudioSeries',RadioComp: Radio2Input, ImgComp: Headphone },
]


const ChapterAudioSeriesTab = ({ selectedTab = 'chapters', setSelectedTab }) => {
    const getWidthOfGlider = () => {
        let width = selectedTab === 'chapters' ? 100 : 120
        // console.log("Sample",width)
        return width
    }
    return(
        <div>
            <ChapterSeriesTabHolder>
                {payoutTabsObject.map((tab, index) => {
                    const { label, name, RadioComp, ImgComp } = tab
                    const isSelectedTab = selectedTab === name
                    return(
                        <>
                            <RadioComp type="radio" id={`radio-${index+1}`} name="tabs" checked={isSelectedTab} onClick={() => setSelectedTab(name)}/>
                            <TabLabel className="tab" id={`label-${index+1}`} htmlFor={`radio-${index+1}`} >
                                <ImgComp fill={isSelectedTab && "rgba(6, 138, 226, 1)"}/>
                                <span style={{ display: isSelectedTab ? 'unset' : 'none'}}>{label}</span>
                            </TabLabel>
                        </>
                    )
                })}
                <Glider id="glider" width={selectedTab === 'chapters' ? 100 : 120}/>
            </ChapterSeriesTabHolder>
        </div>
    )
}

export default ChapterAudioSeriesTab